export interface ChecklistItem {
  id: string;
  title: string;
  description: string;
}

// The safety clearance label is unit-aware (e.g. "10 ft" / "3 m"), so the list is
// built from the user's display unit at render time rather than hardcoded. The
// `id`s are stable across units; checked-state bookkeeping keys off them.
export const buildChecklistItems = (distanceLabel: string): ChecklistItem[] => [
  { id: '1', title: 'Payload loaded', description: 'Confirm the payload is attached' },
  { id: '2', title: 'Payload secured', description: 'Ensure it\'s firmly fastened' },
  { id: '3', title: 'Flight authorized', description: 'Verify approval/permission' },
  { id: '4', title: 'Propellers secure', description: 'Check blades are tightened' },
  { id: '5', title: 'Parachute secure', description: 'Check parachute installation and cable connection' },
  { id: '6', title: 'Clear radius', description: `No obstacles within ${distanceLabel}.` },
  { id: '7', title: 'Safe distance', description: `Stand ${distanceLabel} from drone` },
];

// Static list used only for id-based checked-state bookkeeping (labels never rendered).
export const checklistItems: ChecklistItem[] = buildChecklistItems('');

export const GAMEPAD_MESSAGE = 'CONNECT YOUR GAMEPAD AND PRESS BUTTONS TO BEGIN';
export const AGREEMENT_TEXT = 'Agree and confirm all items in checklist';
export const SIDEBAR_TITLE = '3. Preflight checklist';

